import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import firebase from 'firebase/app'
import { 
  watchAuthChange,
  watchPageChange,
} from './store/observers'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

Vue.config.productionTip = false

// Note: The Firebase config object contains unique, but non-secret identifiers for your Firebase project.
// Visit 'Understand Firebase Projects' to learn more about this config object.
firebase.initializeApp({
  apiKey: 'AIzaSyBY4HzInAy1s_Tyg3WeGddfKHpeQktK384',
  authDomain: 'regal-arbor.firebaseapp.com',
  databaseURL: 'https://regal-arbor.firebaseio.com',
  projectId: 'regal-arbor',
  storageBucket: 'regal-arbor.appspot.com',
  messagingSenderId: '89183815621',
  appId: '1:89183815621:web:26527b952e77f340c8adac'
})

watchAuthChange(store)
watchPageChange(store, router)

new Vue({
  el: '#app',
  store,
  template: '<App/>',
  components: { App },
  router,
  render: h => h(App)
}).$mount('#app')
